import Routes from '../constants/routes';
import analytics from '../services/analytics';
import qualityEvents from '../services/quality-events';
import utmTracker from '../services/utm-tracker';
import Braze from './braze';
import emailHash from './email-hash';
import session from './session';
import serializeQueryParams from './url/serialize-query-params';
import { storedUserData } from './user';

const trackPageView = () => {
    const loc = window.location;
    const params = serializeQueryParams();

    window.SPArouteChanges = window.SPArouteChanges || 0;
    window.SPArouteChanges++;

    if (params.utm_internalpath && loc.href.indexOf(`${Routes.MATERIAL.prefix}/`) >= 0) {
        return;
    }

    // Trim AB test variants description and send only value (A|B|C...)
    // Example: 'B: description' => 'B'
    const processTestSegmentData = (testSegment: string) => {
        const rawData = window.storage.getItem(testSegment);
        let processedData = rawData;

        if (rawData) {
            try {
                const data = JSON.parse(rawData);

                processedData = {};
                Object.keys(data).forEach((key) => {
                    // eslint-disable-next-line prefer-destructuring
                    processedData[key] = data[key].split(':')[0];
                });
                processedData = JSON.stringify(processedData);
            } catch (e) {}
        }

        return processedData;
    };

    analytics.push({
        dynamicURL: window.location.pathname + window.location.search,
        event: 'dynamicPageView',
        emailSHA256: emailHash.getStoredSHA256(),
        page: {},
        referrer: window.location.hostname + window.location.pathname,
        testSegment: processTestSegmentData('testSegment'),
        testSegment0: processTestSegmentData('testSegment0'),
        testSegment1: processTestSegmentData('testSegment1'),
        testSegment10: processTestSegmentData('testSegment10'),
        testSegment11: processTestSegmentData('testSegment11'),
        testSegment12: processTestSegmentData('testSegment12'),
        testSegment13: processTestSegmentData('testSegment13'),
        testSegment14: processTestSegmentData('testSegment14'),
        testSegment2: processTestSegmentData('testSegment2'),
        testSegment3: processTestSegmentData('testSegment3'),
        testSegment4: processTestSegmentData('testSegment4'),
        testSegment5: processTestSegmentData('testSegment5'),
        testSegment6: processTestSegmentData('testSegment6'),
        testSegment7: processTestSegmentData('testSegment7'),
        testSegment8: processTestSegmentData('testSegment8'),
        testSegment9: processTestSegmentData('testSegment9'),
        user: storedUserData()
    });

    Braze.triggerSession();

    qualityEvents.track({
        type: 'pageView'
    });

    utmTracker.track();
};

export default trackPageView;
